let Backbone = require("backbone");

let main = function (Backbone) {
    return Backbone.Model.extend({
        saveScheme: function(){
            return $.post("/membershipScheme/saveForRestaurant", this.toJSON());
        },

        deleteScheme: function(){
            if(this.get("id")){
                return $.post("/membershipScheme/deleteScheme", this.toJSON());
            }
        }
    });
};

let exportedValue = main(Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/settings/MembershipSchemeModel.js